/**
 * Created by esenckewitch on 30.07.2026
 */

const CrossPromoScrollArrows = function (scroll, left, right, options) {
    scroll.updateInnerContent();
    scroll.scrollTo(cleverapps.UI.ScrollView.SCROLLS.UPPER_LEFT);

    const pageSize = Math.max(1, Math.floor((scroll.width - options.tileWidth) / options.tileStep) + 1);
    const numPages = Math.max(1, Math.ceil(options.count / pageSize));

    if (numPages <= 1) {
        left.setVisible(false);
        right.setVisible(false);
        return;
    }

    cleverapps.UI.applyHover(left);
    cleverapps.UI.applyHover(right);

    const getPage = function () {
        const range = scroll.max.x - scroll.min.x;
        if (range === 0) {
            return 0;
        }

        const fraction = (scroll.getContainerPosition().x - scroll.min.x) / range;
        return Math.round(fraction * (numPages - 1));
    };

    const updateArrows = function (page) {
        left.setVisible(page > 0);
        right.setVisible(page < numPages - 1);
    };

    const smoothScrollToPercent = function (percent) {
        percent = Math.min(100, Math.max(0, percent));
        const range = scroll.max.x - scroll.min.x;
        const target = cc.p(range * percent / 100 + scroll.min.x, scroll.getInnerContainer().y);

        scroll.stopScrollAction();
        scroll.runAction(new cc.ScrollAction(target, {
            duration: CrossPromoScrollArrows.SCROLL_DURATION,
            targetPoint: true
        }).easing(cc.easeInOut(CrossPromoScrollArrows.SCROLL_EASE_RATE)));
    };

    const go = function (delta) {
        const page = Math.max(0, Math.min(numPages - 1, getPage() + delta));
        smoothScrollToPercent(page / (numPages - 1) * 100);
        updateArrows(page);
    };

    cleverapps.UI.onClick(right, () => go(1));
    cleverapps.UI.onClick(left, () => go(-1));

    scroll.onUpdatePositionListener = () => {
        updateArrows(getPage());
    };

    updateArrows(getPage());
};

CrossPromoScrollArrows.SCROLL_DURATION = 0.35;
CrossPromoScrollArrows.SCROLL_EASE_RATE = 2;
